module.exports = __webpack_public_path__ + "img/logo4.38638346.svg";